import script from "./TypesService.vue?vue&type=script&setup=true&lang=js"
export * from "./TypesService.vue?vue&type=script&setup=true&lang=js"

import "./TypesService.vue?vue&type=style&index=0&id=65c1903e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c1903e"]])

export default __exports__